import { Component, ComponentInterface, Event, EventEmitter, h, Host, JSX, Prop } from '@stencil/core';
import { Icons } from './../../types/Icons';

import { Constants, Events } from './../../constants';
import { Direction } from '../../utils/getTextDirection';

@Component({
  tag: 'cmm-notification',
  styleUrl: 'cmm-notification.scss',
  shadow: true,
})
export class Notification implements ComponentInterface {
  @Prop() content: string;
  @Prop() direction: Direction = Constants.LEFT_TO_RIGHT;

  @Event({
    eventName: Events.TOGGLE_NOTIFICATION,
    bubbles: true,
  })
  toggleNotification: EventEmitter<MouseEvent>;
  toggleHandler(event: MouseEvent): void {
    this.toggleNotification.emit(event);
  }

  public render(): JSX.Element {
    return (
      <Host>
        <div class="cmm-notification" dir={this.direction}>
          <p class="cmm-notification__content">{this.content}</p>
          <button
            type="button"
            aria-label="Dismiss notification"
            class="cmm-notification__button"
            onClick={(event: MouseEvent): void => this.toggleHandler(event)}
          >
            <cmm-icon name={Icons.CLOSE}></cmm-icon>
          </button>
        </div>
      </Host>
    );
  }
}
